
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class FiltersDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new FiltersForm(this.idPrefix);
        public entityId: number;
        public vouchernos: string[];
        public partyids: number[];
        public vouchertypeid: number;
        public inst;
        public checksuccess: boolean;
        public filterformfor: string;//To check if Filters for Production/Transactions
        constructor() {
            super();

            this.form = new FiltersForm(this.idPrefix);
            this.form.VoucherTypeId.changeSelect2(e => {
                let items;
                var vouchertypeid = parseInt(this.form.VoucherTypeId.value);

                Reports.PriceBifurcationService.GetVouchers({ VoucherTypeId: vouchertypeid }, response => { items = response.Entities }, { async: false });
                //this.form.VoucherNo.items = items;
                //this.form.VoucherNo.setLookupItemArray(items);

                var _items= [];
                for (var i = 0; i < items.length; i++) {
                    var newitem: Serenity.Select2Item = {
                        id: items[i].TransId,
                        text: items[i].VoucherNo,
                        source:items[i]
                    }
                    _items.push(newitem);
                }

                this.form.VoucherNo.setSelect2Items(_items);
                //this.form.VoucherNo.values = [];
            })
        }


        protected getDialogTitle(): string {
            return "Filters";
        }



        onDialogOpen() {
            super.onDialogOpen();
            let vouchers: OMS.VoucherMasterRow[];
            OMS.VoucherMasterService.GetVouchersForTransactions({}, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    vouchers = response.Entities;
                    var _items = [];
                    for (var i = 0; i < vouchers.length; i++) {
                        var newitem: Serenity.Select2Item = {
                            id: vouchers[i].VoucherTypeId.toString(),
                            text: vouchers[i].VoucherTypeName,
                            source: vouchers[i]
                        }
                        _items.push(newitem);
                    }

                    this.form.VoucherTypeId.setSelect2Items(_items);
                }
            }, {async: false})

            if (this.filterformfor == "Production") {
                q.hideField(this.form.PartyId);
                q.hideField(this.form.VoucherNo);
                q.hideField(this.form.VoucherTypeId);

                Production.BagHistoryService.BagList({}, response => {
                    var items = response.Entities;
                    var _items = [];

                    for (var i = 0; i < items.length; i++) {
                        var newitem: Serenity.Select2Item = {
                            id: items[i].BagNo,
                            text: items[i].BagNo,
                            source: items[i]
                        }
                        _items.push(newitem);
                    }

                    this.form.BagNo.setSelect2Items(_items);
                }, { async: false })
            } else if (this.filterformfor == "Transaction") {
                q.hideField(this.form.BagNo);
            }
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        this.checksuccess = true;
                        if (this.filterformfor == "Transaction") {
                            var _vouchernos = this.form.VoucherNo.selectedItems;
                            this.vouchernos = _vouchernos.map(_vouchernos => _vouchernos.VoucherNo);
                            var _partyids = this.form.PartyId.selectedItems;
                            this.partyids = _partyids.map(_partyids => _partyids.LedgerId);
                            this.vouchertypeid = parseInt(this.form.VoucherTypeId.value);
                        }  
                        this.dialogClose();
                        //if (this.form.Username.value == null ||
                        //    Q.isEmptyOrNull(this.form.Username.value)) {
                        //    Q.notifyError("Please Enter Username!");
                        //    return;
                        //}
                        //if (this.form.Password.value == null ||
                        //    Q.isEmptyOrNull(this.form.Password.value)) {
                        //    Q.notifyError("Please Enter Password!");
                        //    return;
                        //}

                        //POSSalesService.Authorize({                            
                        //    Username: this.form.Username.value.toString(),
                        //    Password: this.form.Password.value.toString(),
                        //    VoucherNo: this.voucherno,
                        //    VoucherTypeId: this.vouchertypeid,
                        //    Remark: this.form.Remark.value.toString()
                        //}, response => {
                        //    //Q.notifyInfo(
                        //    //    'Inserted: ' + (response.Inserted || 0) +
                        //    //    ', Updated: ' + (response.Updated || 0));

                        //    //if (response.ErrorList != null && response.ErrorList.length > 0) {
                        //    //    Q.notifyError(response.ErrorList.join(',\r\n '));
                        //    //}
                        //        Q.notifySuccess('Success');
                        //        this.checksuccess = true;
                        //        this.dialogClose();
                        //        return true;
                        //}, { async: false });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}